import * as React from 'react';
import classNames from 'classnames';
import style from './currency.scss';
import {truncateValue} from './utilities';

export type Currencies = 'USD' | 'CAD';
export type CurrencyDisplayType = 'regular' | 'big' | 'bigger' | 'condensed';

type DivElementProps = JSX.IntrinsicElements['div'];

export interface CurrencyProps extends DivElementProps {
  value: number;
  inline?: boolean;
  emphasis?: boolean;
  currency?: Currencies;
  showDecimal?: boolean;
  hideCurrency?: boolean;
  display?: CurrencyDisplayType;
}

const CURRENCY_SYMBOL_MAP = {
  USD: '$',
  CAD: '$',
};

const DEFAULT_CURRENCY = 'USD';

function translateValue(amount: number, showDecimal, condensed = false) {
  if (condensed) {
    return truncateValue(amount);
  }

  return amount.toLocaleString('en-US', {
    maximumFractionDigits: showDecimal ? 2 : 0,
    minimumFractionDigits: showDecimal ? 2 : 0,
  });
}

export function Currency({
  value = 0,
  inline = false,
  style: propsStyle = {},
  emphasis = false,
  currency = DEFAULT_CURRENCY,
  className = '',
  showDecimal = false,
  display = 'regular',
  hideCurrency = false,
  ...restProps
}: CurrencyProps) {
  return (
    <div
      style={propsStyle}
      className={classNames(className, style.container, style[display], {
        [style.inline]: inline,
        [style.emphasis]: emphasis,
        [style.hideCurrency]: hideCurrency,
      })}
      {...restProps}
    >
      <span className={style.currencySymbol}>{CURRENCY_SYMBOL_MAP[currency]}</span>
      <span className={style.value}>{translateValue(value, showDecimal, display === 'condensed')}</span>
      <span className={style.currency}>{currency}</span>
    </div>
  );
}

export default Currency;
